import { Icon } from '@eventbrite/eds-icon';
import { DocumentFill, Link as LinkIcon } from '@eventbrite/eds-iconography';
import { Link } from '@eventbrite/eds-link';
import { cx } from 'emotion';
import React from 'react';
import { GA_ACTION_VIEW_FILE_LINK } from '../../constants';
import { moduleBorderStyle } from './moduleBorderStyle';

interface Props {
    data: { fileUrl: { text: string; url: string } };
    event: any;
    onClick: (event: any, GAEvent: string, url: string) => void;
}

export const FileModule: React.FC<Props> = ({ data, event, onClick }) => {
    const { url = '', text = '' } = data?.fileUrl || {};
    return (
        <div className={cx(moduleBorderStyle, 'eds-l-pad-all-6')}>
            <Link
                to={url}
                target="_blank"
                onClick={onClick(event, GA_ACTION_VIEW_FILE_LINK, url)}
                className="dc-modules__item--file"
            >
                <div
                    className="eds-align--center-vertical"
                    data-testid="link-content"
                >
                    <div>
                        <Icon type={<DocumentFill />} size="small" />
                    </div>
                    <p className="eds-text-bl eds-l-pad-hor-2">{text}</p>
                    <div>
                        <Icon type={<LinkIcon />} size="small" />
                    </div>
                </div>
            </Link>
        </div>
    );
};
